import router from '../../app/router';
import Sms from './sms.vue';

const routes = [
  {
    path: '/login/sms',
    name: 'login/sms',
    component: Sms,
  }
];

router.addRoutes(routes);



// WEBPACK FOOTER //
// ./src/auth/login/install.js